import { directusClient } from '@src/api/DirectusClient.ts';

export class SettingsService {
  async getSettings() {
    return directusClient.getSettings();
  }
}

const settingsService = new SettingsService();
export default settingsService;
